import { useEffect, useState } from 'react';

import Flex from '@utilities/components/Layout/components/Flex';

import FastTracks from '../FastTracks';
import NarrativesCanvas from './components/NarrativesCanvas';
import NarrativesChatWindow from './components/NarrativesChatWindow';
import NarrativesNavigation from './components/NarrativesNavigation';

import styles from './_index.module.scss';

const NarrativesChat = () => {
  const [activePage, setActivePage] = useState('chat');
  const [flowId, setFlowId] = useState(null);
  const [draftFlowState, setDraftFlowState] = useState(null);

  useEffect(() => {
    setFlowId(null);
    setDraftFlowState(null);
  }, [activePage]);

  const renderContent = () => {
    if (activePage === 'templates') {
      return <FastTracks />;
    }

    return (
      <div className={styles['narratives-chat-shell']}>
        <div className={styles['narratives-chat-content']}>
          <div className={styles['narratives-chat-window']}>
            <NarrativesChatWindow
              onFlowSelected={setFlowId}
              onFlowStateChange={setDraftFlowState}
            />
          </div>

          <div className={styles['narratives-chat-canvas']}>
            <NarrativesCanvas flowId={flowId} flowState={draftFlowState} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Flex className={styles['narratives-root']} gap="none">
      <NarrativesNavigation activePage={activePage} onClick={setActivePage} />
      {renderContent()}
    </Flex>
  );
};

export default NarrativesChat;
